import Node from "~/components/JobActivityTimeline/JobEventActorFigure/Node.svg";
import Created from "~/components/JobActivityTimeline/JobEventActorFigure/Created.svg";
import Spinner from "~/components/shared/Spinner";

const ACTOR_FIGURES = {
  NODE: Node,
  CREATED: Created,
} as const;

type Props = {
  type: keyof typeof ACTOR_FIGURES | "PENDING";
};

const STYLE = { width: 20, height: 20 } as const;

/* eslint-disable react/display-name */
export default function JobEventActorFigure(props: Props) {
  return (
    <figure className="mr-2 shrink-0 flex-col">
      {props.type === "PENDING" ? (
        <div className="flex items-center justify-center" style={STYLE}>
          <Spinner color={false} size={16} />
        </div>
      ) : (
        <img style={STYLE} src={ACTOR_FIGURES[props.type]} />
      )}
    </figure>
  );
}
